import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../TopicSection'
import { useSelector } from 'react-redux'
import { getSubTopics } from '../../reducers'

interface SampleRegistriesViewProps {
  slug: string
}

const SampleRegistriesView = ({ slug }: SampleRegistriesViewProps) => {
  const state = useSelector((state: any) => state)
  const { posts } = state

  const subTopics = getSubTopics(state, slug)
  return (
    <>
      {subTopics.map((childTopic: Topic) => (
        <TopicSection
          key={`topic_section_${childTopic.slug}`}
          posts={filterPostsByTopicSlug(posts, childTopic.slug)}
          showAllButton={false}
          showTopics={false}
          topic={{ name: childTopic.name, slug: childTopic.slug }}
        />
      ))}
    </>
  )
}

export default SampleRegistriesView
